import { render, staticRenderFns } from "./upload-videoCover.vue?vue&type=template&id=606a4df4&scoped=true&"
import script from "./upload-videoCover.vue?vue&type=script&lang=js&"
export * from "./upload-videoCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606a4df4",
  null
  
)

export default component.exports